module.exports = __webpack_public_path__ + "99869f0f547b38f7b0dca0925ef7a0c9.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shared/sound/guitar/10_A2.mp3
// module id = 68
// module chunks = 0